import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { formatDashboardDay } from './dashboardDay';

import styles from './ClosingDayLabel.module.scss';

interface ClosingDayLabelProps {
    /** The last complete site day the cards and the table are read on; null when none is. */
    closingDay: string | null;
    className?: string;
}

/**
 * Names the day the KPI cards and the pen table show (U13). The presets end today and the
 * timelines draw today, so without it yesterday's weight or RGI reads as today's. A label,
 * not a sentence: the period notice it stands in for was removed on purpose (U12).
 */
export function ClosingDayLabel(props: ClosingDayLabelProps) {
    const { closingDay, className } = props;
    const { t } = useTranslation();

    if (closingDay === null) return null;
    return (
        <p className={classNames(styles.label, className)}>
            {t('feedingModule.period.asOf', { day: formatDashboardDay(closingDay) })}
        </p>
    );
}
